import React, { Component } from 'react';
import http from '@/utils/http';
import CustomExpansionPanel from '@components/shared/panel/CustomExpansionPanel';
import RecordingsList from './RecordingsList';

class RecordingsContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      recordings: [],
      loading: false,
      error: null,
    };
  }

  componentDidMount() {
    this.fetchRecordings();
  }

  fetchRecordings = () => {
    const { userId } = this.props;

    if (!userId) {
      this.setState({ error: 'User ID is required' });
      return;
    }

    this.setState({ loading: true, error: null });

    http
      .get(`/users/${userId}/recordings`)
      .then((response) => {
        const { recordings = [] } = response.data;
        this.setState({ recordings, loading: false });
      })
      .catch((error) => {
        const errorMessage = error.response?.data?.error || 'Failed to fetch recordings';
        this.setState({ error: errorMessage, loading: false, recordings: [] });
      });
  };

  render() {
    const { recordings, loading, error } = this.state;

    return (
      <div className="recordings-container user-cart-section">
        <CustomExpansionPanel id="recordings-panel" headerText="PostHog Recordings">
          <div className="panel__content w-100">
            {loading && (
              <div className="text-center p-3">
                <span>Loading recordings...</span>
              </div>
            )}

            {error && (
              <div className="alert alert-warning m-3" role="alert">
                {error}
              </div>
            )}

            {!loading && !error && (
              <RecordingsList recordings={recordings} />
            )}
          </div>
        </CustomExpansionPanel>
      </div>
    );
  }
}

export default RecordingsContainer;
